import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/invoices/create`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/invoices/create`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/invoices/create`;
